/** Texts of the objects pages (en), below `projects.objects`. */
export const objects = {
  title: 'Objects',
  description: 'Buildings and properties where projects take place, with their history.',
  new: 'New object',
  search: 'Search objects',
  searchPlaceholder: "Name, number, customer's no., address, owner …",
  archive: 'Archive',
  current: 'Current',
  archived: 'Archived',
  specialBuilding: 'Special building',
  georeferenced: 'GPS placement',
  buildingClassValue: 'BC {{value}}',
  yes: 'Yes',
  no: 'No',
  exportName: 'Objects',
  views: 'View',
  list: 'List',
  map: 'Map',
  mapLabel: 'Objects on the map',
  mapEmpty: 'No object on the map',
  mapEmptyHint: 'Objects appear here once their address was chosen through the address search.',
  notOnMap: 'not on the map',
  empty: 'No objects yet',
  emptyHint: 'Create the first building with “New object”.',
  emptyReadOnly: 'Objects appear here once they are created.',
  noMatches: 'No matching objects',
  noMatchesHint: 'Change the search or filters.',
  fields: {
    project: 'Project',
    name: 'Name',
    number: 'Object number',
    customerNumber: "Customer's object number",
    customerNumberShort: "Customer's no.",
    address: 'Address',
    street: 'Street',
    houseNumber: 'House number',
    postcode: 'Postcode',
    city: 'City',
    countryCode: 'Country',
    state: 'Federal state',
    owner: 'Owner',
    operator: 'Operator',
    usage: 'Use',
    buildingClass: 'Building class',
    buildingClassShort: 'BC',
    specialBuilding: 'Special building',
    georeferenced: 'Place findings by GPS',
    notes: 'Notes',
    projectCount: 'Projects',
  },
  form: {
    createTitle: 'New object',
    editTitle: 'Edit object',
    more: 'More details',
    created: 'Object “{{name}}” created.',
    updated: 'Changes saved.',
    projectHint:
      'The project the building belongs to. Further projects can be assigned later on the project page.',
    nameHint: 'What the building is called in the office, e.g. “Harbour primary school”.',
    numberHint: 'The company types object numbers in. Without one the object has no number.',
    customerNumberHint:
      'The number the customer files the building under, e.g. the property number. The own object number stays as it is.',
    address: 'Address',
    addressSearch: 'Search address',
    addressSearchHint: 'Fills in street and city and sets the point on the map.',
    pointHint:
      'Set by the address search. For places without a fitting address, e.g. a construction site, choose the point on the map, enter coordinates or take your own location.',
    notLocated: 'No point yet: the object does not show on maps.',
    stateHint:
      'Proposed by the address search. Decides which state law applies, e.g. in inspections.',
    noState: 'Not given',
    usageHint: 'E.g. office, school, hospital, place of assembly.',
    noBuildingClass: 'Not given',
    georeferencedHint:
      'For sites along a line such as railway or road works: inspections of the object then place findings by GPS on a map instead of on plans. Each inspection can change it.',
    specialBuildingHint:
      'Special building under the state building code, e.g. high-rise or hospital.',
    reload: 'Reload',
    conflictHint: 'Reload shows the current state. Entries in this dialog are lost.',
  },
  page: {
    masterData: 'Master data',
    masterDataEmpty: 'No number, address, owner or building data yet.',
    location: 'Location',
    mapLabel: 'Location of {{name}}',
    changed: 'changed {{when}}',
    customerNumber: 'at the customer {{number}}',
    notFound: 'Object not found',
    notFoundHint: 'The address is wrong, the object was deleted or belongs to another company.',
    archive: 'Archive',
    archiveTitle: 'Archive object?',
    archiveDescription:
      '“{{name}}” will be missing from the list and from pickers. Projects keep their reference, and it can be restored at any time.',
    archivedToast: 'Object archived.',
    archivedTitle: 'Archived',
    archivedSince: 'Since {{when}}. Archived objects are missing from pickers.',
    restore: 'Restore',
    restored: 'Object restored.',
    projects: 'Projects at the object',
    projectsHint: 'All projects at this building that you may see.',
    projectsOf: 'Projects at {{name}}',
    projectNumber: 'Number',
    projectTitle: 'Project',
    projectStatus: 'Status',
    projectPeriod: 'Period',
    noProjects: 'No projects yet',
    noProjectsHint: 'Projects appear here once they name this object.',
    projectClient: 'Client',
    createProject: 'Create project',
  },
  federalStates: {
    BW: 'Baden-Württemberg',
    BY: 'Bavaria',
    BE: 'Berlin',
    BB: 'Brandenburg',
    HB: 'Bremen',
    HH: 'Hamburg',
    HE: 'Hesse',
    MV: 'Mecklenburg-Western Pomerania',
    NI: 'Lower Saxony',
    NW: 'North Rhine-Westphalia',
    RP: 'Rhineland-Palatinate',
    SL: 'Saarland',
    SN: 'Saxony',
    ST: 'Saxony-Anhalt',
    SH: 'Schleswig-Holstein',
    TH: 'Thuringia',
  },
  section: {
    caption: 'Objects of this organisation',
    empty: 'No objects',
    emptyHint:
      'Objects owned or operated by the organisation and the objects of its projects appear here.',
    relation: 'Relation',
    owner: 'Owner',
    operator: 'Operator',
    project: 'Project {{number}}',
  },
  picker: {
    placeholder: 'Choose object',
    search: 'Search name, number or city',
    customerNumber: 'Customer: {{number}}',
    empty: 'No object found.',
    create: 'Create object',
    createNamed: 'Create “{{name}}” as object',
    loading: 'Loading …',
    unavailable: 'Not available',
  },
  errors: {
    name: 'Enter a name.',
    countryCode: 'Enter a two-letter country code, e.g. DE.',
    coordinates: 'Coordinates incomplete. Choose the address through the search again.',
    buildingClass: 'Choose building class 1 to 5.',
    state: 'Choose a federal state from the list.',
    organization: 'The chosen organisation is no longer available.',
    invalid: 'Check the entry.',
    invalidInput: 'Check the entries.',
    versionConflict: 'Changed by someone else in the meantime.',
    notFound: 'Object not found. It may have been deleted.',
    forbidden: 'A permission is missing for this.',
  },
};
